import { AuthenticationData } from '../store/authentication';
import { FinalOffer } from '../types/OfferTypes';
import { apiClient } from './apiClient';

export const getFinalOffer = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string,
    authenticationData?: AuthenticationData,
): Promise<FinalOffer> => {
    return apiClient<FinalOffer>(`${proxyBaseUrl}/offers/${arn}/final_offers`, {
        method: 'GET',
        apiKey,
        authenticationData,
        sentryTag: 'get_final_offer',
        sentryExtra: { arn },
    });
};
